import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Not import.meta.env.MODE: `vite build` sets that to "production" for every env.
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  // v11 replaced `sendDefaultPii: true` with `dataCollection`, whose defaults
  // already collect user info, cookies, headers and query params.
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
